const PrescriptionEvent = Object.freeze({
  STARTED: 'Started',
  PAUSED: 'Paused',
  RESTARTED: 'Restarted',
  INCREASED_DOSAGE: 'Increased Dosage',
  DECREASED_DOSAGE: 'Decreased Dosage',
});

export default PrescriptionEvent;
